import { Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const SliderWrapper = styled.div`
  margin-top: ${Spacing.S8};
`
